<ng-container *ngIf="scenariosPartages;else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div class="cell shrink">
      </div>
    </div>
  </div>

  <div class="card-body">

    <div class="d-block padding-h ">
      <div class="grid-x">
        <span class="c-dark-gray margin-b i-block"
              style="font-weight:500;">{{scenariosPartages.nomDernierScenario}}</span>
      </div>
      <div class="grid-x">
        <span class="c-medium-gray margin-b i-block"
              style="font-weight:500;">{{"widget.inviseo-scenarios-partages.date-derniere-maj" | translate :{'dateDerniereMaj': scenariosPartages.dateDerniereMaj} }}</span>
      </div>
      <div class="d-block margin-h-l padding-v border-t border-b">
        <div class="grid-x">
          <div class="cell shrink">
            <div class="badge-icon-scenario bg-warning c-white">
              <span class="opt opt-prospective" style="font-size:2rem;"></span>
            </div>
          </div>
          <div class="cell shrink">
            <p class="nb-scenario i-block padding-h-s margin-reset">{{scenariosPartages.nombreScenarioPartages}}</p>
          </div>
          <div class="cell auto margin-t-s">
            <p class="label-scenario margin-reset margin-t-xs">{{"widget.inviseo-scenarios-partages.shared-scenarios" | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-footer">
    <a (click)="actionEvent.emit('widget.inviseo-scenarios-partages.link-label.' + widget.widgetName)"
       class="button insito"
       [href]="getRedirectLink()">
      <span>{{"widget.inviseo-scenarios-partages.load-last-scenario" | translate}}</span>
    </a>
  </div>
</ng-container>

<ng-template #noData>
  <app-widget-message [message]="'widget.inviseo-scenarios-partages.no-scenario'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>
